import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div.attrs({ className: 'ui__block' })`
  border-top: 3px solid ${(props) => props.theme.colours.accent};
  padding-top: 15px;
`;

const Block = ({ title, subtitle, children, ...props }) => (
  <Container {...props}>{children}</Container>
);

Block.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

Block.defaultProps = {
  children: null,
  title: null,
  subtitle: null
};

export default Block;
